import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { WIDGETS_DELETED } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { fireMPOnDeleteWidget } from 'libs/third-party/Mixpanel/mixpanel.helper';
import { useAppStore } from 'modules/Editor/store/hooks';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store/hooks';
import { selectWidget } from 'modules/Editor/store/infographSelector';
import { removeWidget } from 'modules/Editor/store/infographSlice';
import { selectActivePage } from 'modules/Editor/store/pageSelector';
import { RootState } from 'modules/Editor/store/store';
import { setActiveWidget } from 'modules/Editor/store/store';
import {
  selectActiveWidgetIds,
  selectActiveWidgetType,
  selectHasActiveWidget,
} from 'modules/Editor/store/widgetSelector';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetType } from 'types/widget.types';
import { AllWidgetData } from 'widgets/Widget.types';

export const DeleteMenu = memo(() => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false });
  const dispatch = useAppDispatch();
  const store = useAppStore();

  const hasActiveWidget = useAppSelector(selectHasActiveWidget);
  const isDisabled = !hasActiveWidget;

  const label = t('delete');

  const removeActiveWidgets = () => {
    const storeState = store.getState() as RootState;

    const activePageId = selectActivePage(storeState);
    const activeWidgetIds = selectActiveWidgetIds(storeState);

    if (activeWidgetIds.length === 1) {
      const widgetType = selectActiveWidgetType(storeState) as WidgetType;
      const widgetData = selectWidget(activeWidgetIds[0])(storeState);

      fireMPOnDeleteWidget(widgetType, widgetData as AllWidgetData);
    } else if (activeWidgetIds.length > 1) {
      Mixpanel.track(WIDGETS_DELETED.eventName);
    }

    dispatch(removeWidget({ pageId: activePageId, widgetIds: activeWidgetIds }));
    dispatch(setActiveWidget([]));
  };

  return (
    <Tooltip hasArrow placement='bottom-start' label={label} bg='black'>
      <IconButton
        isDisabled={isDisabled}
        size='sm'
        variant={'ghost-with-active'}
        aria-label={label}
        _active={{ bg: 'hover.blue', '& path': { fill: 'upgrade.blue.700' } }}
        icon={<DeleteIcon />}
        onClick={removeActiveWidgets}
      />
    </Tooltip>
  );
});

DeleteMenu.displayName = 'DeleteMenu';
